// extracted by mini-css-extract-plugin
export default {"header":"profile_preview_skills-module___header___ac6e7f74","expandButton":"profile_preview_skills-module___expandButton___d9add120"};